// Set destination middlewares for Motos.net.
export default []
